<!--
  创建时间：2024/8/23 14:20
  创建人：toyehuang
  PurchaseTransaction 首页 项目信息模块
-->

<template>
  <div class="purchase-block f-column-b mt-30" :style="computedHeightStyle">
    <block-head :title="title" :subtitle="subtitle" :icon="icon" :more-btn-url="moreBtnUrl">
      <ul  class="f-start-c flex-1">
        <li v-for="nt in projectTypeList" :key="nt[code]" class="fc99 mr-10" :class="{active: nt[code] === activeType}" @click="changeProjectType(nt[code])">{{ nt[label] }}</li>
      </ul>
    </block-head>
    <div class="smf clearfix">
        <ul  v-if="list.length">
            <li>
                <a href="" target="_blank" class="link">
                    
                    <span class="title-cg">
              <h3 class="new-title-text" title="防城港中港建设工程有限责任公司-水街商业综合体提升改造工程EPC总承包-商场油烟管道工程（一）-采购公告">
                      防城港中港建设工程有限责任公司-水街商业综合体提升改造工程EPC总承包-商场油烟管道工程（一）-采购公告
              </h3>
              <span class="new-title-bottom">
                  <span class="fr"><em>公示中</em></span>
                        <span title="" style="margin-top:13px;">
                            浏览次数
                                <em>34</em>次
                        </span>
                    </span>
                </span>
                    <span class="enquiry-materials">
                    
                    
                    </span>

                    
                    
                      <span class="item-price item">
                        <label>预算金额：</label><span class="fcdd3 bold money" title="2,100,200.00元">2,100,200.00元</span>
                    </span>
                    <span class="item-price item ">
                    <label>保证金额：</label><span class="money" title="详见公告">详见公告</span>
                    </span>
                    
                    <span class="item-price item">
                    
                    
                        <label>报名截止：</label><span>2025-04-04 15:57:33</span>
                    
                    
                    
                    </span>
                    <span class="item-company" title="广西北港建设开发有限公司">广西北港建设开发有限公司</span>
                </a>
            </li>
        
            <li>
                <a href="" target="_blank" class="link">
                    
                    <span class="title-cg">
              <h3 class="new-title-text" title="柳州钢铁股份有限公司智慧库房信息化管理平台项目招标公告">
                      柳州钢铁股份有限公司智慧库房信息化管理平台项目招标公告
              </h3>
              <span class="new-title-bottom">
                  <span class="fr"><em>公示中</em></span>
                        <span title="" style="margin-top:13px;">
                            浏览次数
                                <em>71</em>次
                        </span>
                    </span>
                </span>
                    <span class="enquiry-materials">
                    
                    
                    </span>

                    
                    
                      <span class="item-price item">
                        <label>预算金额：</label><span class="fcdd3 bold money" title="4,403,156.00元">4,403,156.00元</span>
                    </span>
                    <span class="item-price item ">
                    <label>保证金额：</label><span class="money" title="详见公告">详见公告</span>
                    </span>
                    
                    <span class="item-price item">
                    
                    
                        <label>报名截止：</label><span>2025-04-18 09:00:00</span>
                    
                    
                    
                    </span>
                    <span class="item-company" title="云之龙咨询集团有限公司">云之龙咨询集团有限公司</span>
                </a>
            </li>
        
            <li>
                <a href="" target="_blank" class="link">
                    
                    <span class="title-cg">
              <h3 class="new-title-text" title="柳州钢铁股份有限公司物资仓储一体化管理平台招标公告">
                      柳州钢铁股份有限公司物资仓储一体化管理平台招标公告
              </h3>
              <span class="new-title-bottom">
                  <span class="fr"><em>公示中</em></span>
                        <span title="" style="margin-top:13px;">
                            浏览次数
                                <em>75</em>次
                        </span>
                    </span>
                </span>
                    <span class="enquiry-materials">
                    
                    
                    </span>

                    
                    
                      <span class="item-price item">
                        <label>预算金额：</label><span class="fcdd3 bold money" title="3,309,960.00元">3,309,960.00元</span>
                    </span>
                    <span class="item-price item ">
                    <label>保证金额：</label><span class="money" title="详见公告">详见公告</span>
                    </span>
                    
                    <span class="item-price item">
                    
                    
                        <label>报名截止：</label><span>2025-04-18 09:00:00</span>
                    
                    
                    
                    </span>
                    <span class="item-company" title="云之龙咨询集团有限公司">云之龙咨询集团有限公司</span>
                </a>
            </li>
        
            <li>
                <a href="" target="_blank" class="link">
                    
                    <span class="title-cg">
              <h3 class="new-title-text" title="交投荣和樾园（1#、2#、7#、8#、11#-19#楼）园林景观工程施工资格预审公告">
                      交投荣和樾园（1#、2#、7#、8#、11#-19#楼）园林景观工程施工资格预审公告
              </h3>
              <span class="new-title-bottom">
                  <span class="fr"><em>公示中</em></span>
                        <span title="" style="margin-top:13px;">
                            浏览次数
                                <em>90</em>次
                        </span>
                    </span>
                </span>
                    <span class="enquiry-materials">
                    
                    
                    </span>

                    
                    
                      <span class="item-price item">
                        <label>预算金额：</label><span class="fcdd3 bold money" title="11,389,200.00元">11,389,200.00元</span>
                    </span>
                    <span class="item-price item ">
                    <label>保证金额：</label><span class="money" title="详见公告">详见公告</span>
                    </span>
                    
                    <span class="item-price item">
                    
                    
                        <label>报名截止：</label><span>2025-04-03 18:00:00</span>
                    
                    
                    
                    </span>
                    <span class="item-company" title="广西交投宏冠工程咨询有限公司">广西交投宏冠工程咨询有限公司</span>
                </a>
            </li>        
        </ul>
        <no-data v-else :no-txt="noTxt" :no-img="noImg" :text="$attrs.text" />
    </div>
  </div>
</template>

<script>
import {
  getConstantDic,
  PROJECT_STATUS_OPTIONS,
  PROJECT_TYPE_OPTIONS,
  SELECT_OPTION_CONFIG
} from "@/utils/constant";
import purchaseApi from "@/api/porperty";
import NoData from "@/components/NoData.vue";
import BlockHead from "@/views/home/components/BlockHead.vue";

export default {
  name: "InvitationProcurement",
  components: { BlockHead, NoData },
  props: {
    defaultParams: {
      type: Object,
      default: () => ({})
    },
    icon: {
      type: String,
      default: "purchase"
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    hidTab: {
      type: Boolean,
      default: false
    },
    // 需要隐藏的 column
    hidColumns: {
      type: Array,
      default: () => []
    },
    // 模块高度
    blockHeight: {
      type: [Number, String],
      default: "458px"
    },
    // 最多显示多少行
    rows: {
      type: [Number, String],
      default: 8
    },
    noTxt: {
      type: Boolean,
      default: true
    },
    noImg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      projectTypeList: getConstantDic(PROJECT_TYPE_OPTIONS),
      // 项目状态  未开始：0 报名中：1 报名截止：2 公示中：3 公示结束 ：4 已中标：5 已废标：6）
      statusList: Object.values(PROJECT_STATUS_OPTIONS),
      noticeType: "",
      code: SELECT_OPTION_CONFIG.CODE,
      label: SELECT_OPTION_CONFIG.LABEL,
      list: [],
      orderType: "default",
      projectType: ""
    };
  },
  // 监听属性 类似于data概念
  computed: {
    moreBtnUrl() {
      return this.$router.resolve({ path: "/purchase/list/xmxx", query: { noticeType: this.noticeType, projectType: this.projectType, ...this.defaultParams }})?.href
    },
    activeType() {
      return this.projectType || this.noticeType || ""
    },
    computedHeightStyle() {
      let height = this.blockHeight
      if (typeof this.blockHeight === "string") { height = height.replace("px", "") }
      return { height: height + "px" }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList()
  },
  // 方法集合
  methods: {
    changeProjectType(code) {
      this.noticeType = ""
      this.projectType = code
      this.getList()
    },
    // 获取列表
    getList() {
      const params = {
        pageNo: 1,
        pageSize: this.rows,
        noticeType: this.noticeType,
        projectType: this.projectType,
        orderType: this.orderType || "default", // (默认：default  报名截止时间升序：baoMingEndDate_up 报名截止时间降序：baoMingEndDate_down)
        ...this.defaultParams
      }
      purchaseApi.page(params).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          const list = data.list || []
          this.total = data.total || 0
          list.forEach(e => {
            e.status_name = this.statusList.find(f => f.code === e.status)?.label
          })
          this.list = (data.list ?? []).slice(0, 4)
        }
      })
    },
    headerCellStyle({ columnIndex }) {
      return "background-color: #f9f9f9;padding: 4px 0;"
    },
    cellStyle({ columnIndex, rowIndex }) {
      let str = "padding: 9px 0;cursor:pointer;"
      if (columnIndex === 4) {
        str += "display: flex;justify-content: center;"
      }
      if (rowIndex === 7) {
        str += "border: none;"
      }
      return str
    },
    // 行点击
    rowClick(row) {
      const route = this.$router.resolve({
        path: "/purchase/detail/xmxx",
        query: {
          id: row.id,
          noticeType: this.noticeType || this.defaultParams.noticeType
        }
      })
      window.open(route.href)
    },
    // 排序
    handleSortChange({ order }) {
      this.orderType = order === "descending" ? "baoMingEndDate_down" : order === "ascending" ? "baoMingEndDate_up" : "default"
      this.getList("0")
    }
  }
};
</script>

<style scoped lang="scss">
.purchase-block{
  width: 1200px;
  margin: 25px auto 0;
}
.smf{width: 100%; padding:20px 0px 0px;}
.smf ul{width: 102%;}
.smf ul li{margin:0px 20px 0px 0px;zoom:1;  width:285px;height:300px;margin-bottom: 20px; float: left;position: relative;background: #fff;border:1px #e5e5e5 solid;overflow: hidden;}
.smf ul li .link{padding: 0px 10px;display: inline-block;color:#666;}
.smf ul li:hover {  box-shadow: 0 2px 10px 0 rgba(0,0,0,.45);}
.smf ul li .link .title-cg{margin-top:15px;height:85px;display: inline-block;width: 100%;}
.smf ul li .link .title-cg .new-title-text{font-weight: bold;overflow: hidden;line-height: 20px;height: 40px;
  -webkit-line-clamp: 2; display:inline-block; display: -webkit-box; color: #333; -webkit-box-orient: vertical;    font-size: 14px;   white-space: normal;}
.smf ul li .link:hover .title-cg  .new-title-text{color: #dd362d;}
.smf ul li .link .title-cg .new-title-bottom{height: 46px;line-height: 46px;border-bottom: 1px #ddd solid;width: 100%;
  display: inline-block;font-size: 12px;}
.smf ul li .link .title-cg .new-title-bottom em{color: #dd362d;}
.smf ul li .link .enquiry-materials{width: 100%;display: inline-block;position: relative;height: 30px;color: #666;}
.smf ul li .link .enquiry-materials .liang{border:1px #dd362d solid;float: left;margin: 10px 10px 0px 0px;border-radius: 50px;padding: 0px 10px; height:18px; line-height: 18px; color: #dd362d;}
.smf ul li .link .item-price{width: 100%;display: inline-block;height: 30px;line-height: 30px;display: inline-block;}
.smf ul li .link .item-price label{color: #999; float: left;}
.smf ul li .link .item-price .money{    float: left;    margin-right: 5px;    -webkit-line-clamp: 1;
  height: 30px;    display: -webkit-box;    max-width: 185px;    -webkit-box-orient: vertical;    white-space: normal;
  overflow: hidden;}
.smf ul li .link .item-company{height: 36px;line-height: 36px;color: #666;margin-top: 10px;
      -webkit-line-clamp: 1; display:inline-block; display: -webkit-box;  -webkit-box-orient: vertical;    font-size: 14px;   white-space: normal;    padding-left: 70px;   background: url(@/assets/images/home/company2.png)no-repeat left center;overflow: hidden;}


</style>
